import axios from "axios";
import { useNavigate } from "react-router-dom";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/api`,
  withCredentials: true,
});

// Interceptor to handle expired tokens
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("accessToken");
      // Navigate to login
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
